export default __webpack_public_path__ + "static/media/pricingPageLocation.93e15b92.jpg";